const defaultData = {
  cartCount: 0,
  checkoutCount: 0,
};
export const cartDetailReducer = (cartDetail = defaultData, action) => {
  const { type, payload } = action;
  switch (type) {
    case "CART_ITEMS":
      const { cartCount, checkoutCount } = payload;

      return {
        ...cartDetail,
        cartCount,
        checkoutCount,
      };
    case "REMOVE_ITEMS":
      const { totalItem, productIds } = payload;

      return {
        ...cartDetail,
        cartCount: cartDetail.cartCount - totalItem[0],
      };
    case "ADD_TO_CART_BTN":
      return {
        ...cartDetail,
        cartCount: cartDetail.cartCount + 1,
      };
    case "ADD_TO_CART_ADDER":
      return {
        ...cartDetail,
        cartCount: cartDetail.cartCount + 1,
      };
    case "LOGOUT":
      localStorage.clear();
      return {
        cartCount: 0,
        checkoutCount: 0,
      };
    case "CHAT_MESSAGE":
      return {
        ...cartDetail,
        message: payload,
      };
    case "SUBTRACT_TO_CART":
      const { idx } = payload;

      return {
        ...cartDetail,
        cartCount: cartDetail.cartCount - 1,
      };
    case "SEND_NOTIF":
      return {
        ...cartDetail,
        notify: payload,
      };

    case "REMOVE_TO_CART":
      return {
        ...cartDetail,
        cartCount: cartDetail.cartCount - 1,
      };

    default:
      return cartDetail;
  }
};
